module.exports = __webpack_public_path__ + "img/bory_mapa_seda.665f8f7d.png";